import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import {
  Breadcrumbs, Card, CardActionArea, CardContent, Typography, Grid2, Box,
} from '@mui/material';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';
import AppShell from './components/AppShell';
import api from './services/api';

const AddQuotasHome = () => {
  const { surveyId } = useParams();
  const [survey, setSurvey] = useState(null);

  useEffect(() => {
    api.get(`/surveys/${surveyId}/`).then((res) => setSurvey(res.data));
  }, [surveyId]);

  if (!survey) return null;

  return (
    <AppShell>
      <Breadcrumbs separator=">" sx={{ mb: 4 }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>Home</Link>
        <Link to={`/project/${survey.project}`} style={{ textDecoration: 'none', color: 'inherit' }}>{survey.project_name}</Link>
        <Link to={`/survey/${surveyId}`} style={{ textDecoration: 'none', color: 'inherit' }}>{survey.name}</Link>
        <Typography color="textPrimary">Alchemer quota setup</Typography>
      </Breadcrumbs>

      <Typography variant="h4" fontFamily="'Work Sans', sans-serif" fontWeight={700} sx={{ mb: 1 }}>
        Alchemer quota setup
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Create quotas in Alchemer for this survey.
      </Typography>

      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
          <Card
            elevation={0}
            sx={{
              border: '1px solid #e0e0e0',
              borderRadius: 3,
              transition: 'box-shadow 0.2s, transform 0.2s',
              '&:hover': { boxShadow: '0 4px 20px rgba(0,0,0,0.1)', transform: 'translateY(-2px)' },
            }}
          >
            <CardActionArea component={Link} to={`/survey/${surveyId}/add-quotas/uk-nat-rep`} sx={{ p: 1 }}>
              <CardContent sx={{ textAlign: 'center', py: 3 }}>
                <Box sx={{ bgcolor: 'primary.light', borderRadius: 2, p: 1.5, display: 'inline-flex', mb: 1.5 }}>
                  <PeopleRoundedIcon sx={{ fontSize: 32, color: 'primary.main' }} />
                </Box>
                <Typography variant="h6" fontFamily="'Work Sans', sans-serif" fontWeight={600}>UK Nat Rep</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
          <Card
            elevation={0}
            sx={{
              border: '1px solid #e0e0e0',
              borderRadius: 3,
              transition: 'box-shadow 0.2s, transform 0.2s',
              '&:hover': { boxShadow: '0 4px 20px rgba(0,0,0,0.1)', transform: 'translateY(-2px)' },
            }}
          >
            <CardActionArea component={Link} to={`/survey/${surveyId}/add-quotas/manual`} sx={{ p: 1 }}>
              <CardContent sx={{ textAlign: 'center', py: 3 }}>
                <Box sx={{ bgcolor: 'primary.light', borderRadius: 2, p: 1.5, display: 'inline-flex', mb: 1.5 }}>
                  <EditNoteRoundedIcon sx={{ fontSize: 32, color: 'primary.main' }} />
                </Box>
                <Typography variant="h6" fontFamily="'Work Sans', sans-serif" fontWeight={600}>Manual</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
          <Card
            elevation={0}
            sx={{
              border: '1px solid #e0e0e0',
              borderRadius: 3,
              transition: 'box-shadow 0.2s, transform 0.2s',
              '&:hover': { boxShadow: '0 4px 20px rgba(0,0,0,0.1)', transform: 'translateY(-2px)' },
            }}
          >
            <CardActionArea component={Link} to={`/survey/${surveyId}/add-quotas/bulk`} sx={{ p: 1 }}>
              <CardContent sx={{ textAlign: 'center', py: 3 }}>
                <Box sx={{ bgcolor: 'primary.light', borderRadius: 2, p: 1.5, display: 'inline-flex', mb: 1.5 }}>
                  <TableChartRoundedIcon sx={{ fontSize: 32, color: 'primary.main' }} />
                </Box>
                <Typography variant="h6" fontFamily="'Work Sans', sans-serif" fontWeight={600}>Bulk Upload</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid2>
      </Grid2>
    </AppShell>
  );
};

export default AddQuotasHome;
